import { AnalyticsField } from '@types'

export const COMMITMENTS_SEARCHABLE_TEXT = [
  AnalyticsField.ACCOUNT,
  AnalyticsField.ASSET
]

export const COMMITMENTS_POSIBLE_VALUES = [
  AnalyticsField.ORIGINAL_COMMITMENT,
  AnalyticsField.REMAINING_COMMITMENT,
  AnalyticsField.INVESTED_CAPITAL,
  AnalyticsField.RECALLABLE_CAPITAL,
  AnalyticsField.RETURNED_CAPITAL,
  AnalyticsField.INCOME,
  AnalyticsField.TOTAL_DISTRIBUTION,
  AnalyticsField.GAIN_LOSS,
  AnalyticsField.CURRENT_BALANCE
]
